import type { BreadcrumbList, WithContext } from "schema-dts";
import { PROJECT_NAME } from "@shared/config/GlobalText";
import { configApi } from "@shared/lib/configApi";
import { RouterConfig } from "@shared/lib/routerConfig";

export const getBreadcrumbBlogPostSchema = (
    postTitle: string,
    canonicalUrl: string
): WithContext<BreadcrumbList> => {
    return {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
            {
                "@type": "ListItem",
                position: 1,
                item: {
                    "@type": "Thing",
                    "@id": configApi.API_PUBLIC_DOMAIN,
                    name: PROJECT_NAME
                }
            },
            {
                "@type": "ListItem",
                position: 2,
                item: {
                    "@type": "Thing",
                    "@id": `${configApi.API_PUBLIC_DOMAIN}${RouterConfig.BLOG}`,
                    name: "Блог"
                }
            },
            {
                "@type": "ListItem",
                position: 3,
                item: {
                    "@type": "Thing",
                    "@id": canonicalUrl,
                    name: postTitle
                }
            }
        ]
    };
};